export default __webpack_public_path__ + "static/media/logo-election2016.fea9fb6b.svg";